<div class="sw-cms-el-config-moorl-person">
    <sw-cms-mapping-field
        v-model:config="element.config.salutationId"
        value-types="string"
        entity="salutation"
    >
        <sw-entity-single-select
            :label="$tc('moorl-foundation.field.salutation')"
            entity="salutation"
            labelProperty="displayName"
            v-model:value="element.config.salutationId.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.title"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.title')"
            v-model="element.config.title.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.firstName"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.firstName')"
            v-model="element.config.firstName.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.lastName"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.lastName')"
            v-model="element.config.lastName.value"
        />
    </sw-cms-mapping-field>
    <sw-cms-mapping-field
        v-model:config="element.config.company"
        value-types="string"
    >
        <mt-text-field
            :label="$tc('moorl-foundation.field.company')"
            v-model="element.config.company.value"
        />
    </sw-cms-mapping-field>
</div>